export const CREATED = 'CREATED'
export const ACCEPTED = 'ACCEPTED'
export const REJECTED = 'REJECTED'
